import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import {MatTableDataSource} from '@angular/material/table';
import { FormGroupDirective, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { IfStmt } from '@angular/compiler';
import { AdminService } from 'src/app/Common/Services/admin.service';
import { MatSort, MatPaginator } from '@angular/material';

export interface PeriodicElement {
  
  page: string;
  product: string;
  imgname: string;
  position: number;
}


export interface filetype {
  key: string;
  value: string;
}

@Component({
  selector: 'app-admin-image-upload',
  templateUrl: './admin-image-upload.component.html',
  styleUrls: ['./admin-image-upload.component.css']
})
export class AdminImageUploadComponent implements OnInit {

  displayedColumns: string[] = ['imagepage','bannerimage', 'filename','action'];
  dataSource;
  imguploadList:PeriodicElement[] =[];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  fileToUpload: File = null;
  imguploadForm:FormGroup;
  pagetypes:any[]=[];
  products:any[]=[];

  public selectprod : boolean = false;
  constructor(public global: GlobalService,private toastr: ToastrService,public adminservice:AdminService,private _formbuilder: FormBuilder,public loginservice:LoginService) { 
    this.imguploadForm=this._formbuilder.group({
      imagepage: ['',[Validators.required]],
      product: ['',[Validators.required]],
      file:['',[Validators.required]]
    });
  }

  ngOnInit() {
    
    this.getAllLOvs("imagepage");
    this.getimageuploadlist();
  }

  
  getAllLOvs(value:string){
    this.loginservice.getPageLOVs(value).subscribe((res:any)=>{
      if(res.responseBody != undefined){
        console.log("LOVs",res.responseBody);
        this.pagetypes = res.responseBody.imagePageList;
      }
    
    })
  }

  handleFileInput(files: FileList){
     
    console.log("uploaded");
    this.fileToUpload = files.item(0);
  }


  pagechange(val){
    
    if(val =="Business Select"){
      val = "Business";
    }
    this.loginservice.getprodlist(val).subscribe((res:any)=>{
       
      if(res.responseBody.Details != undefined){
        console.log("List",res.responseBody);
        this.products = res.responseBody.Details;
        this.selectprod = true;
      }else{
        this.selectprod = false;
        this.imguploadForm.value.product="NA";
      }
    })
  }

  submit(){
    
    if(this.imguploadForm.value.imagepage !=""){
      if(this.imguploadForm.value.product !=""){
    if(this.fileToUpload !=null){
   
      let formData: FormData = new FormData();
      formData.set("pagename", this.imguploadForm.value.imagepage);  
      formData.set("bannerimgname", this.imguploadForm.value.product);  
      formData.append("file", this.fileToUpload); 
      this.adminservice.adminimgupload(formData).subscribe((res:any)=>{
      
      console.log(res);
      this.toastr.success(res.responseBody.ValidateMsg, undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
       this.imguploadForm.reset();
       this.getimageuploadlist();
    })
    }else{
      this.toastr.error("Please Upload the Image", undefined, {
        positionClass: 'toast-bottom-right',
        timeOut: 6000
      });
    }
  }else{
    this.toastr.error("Please Selecct the Banner Image Name", undefined, {
      positionClass: 'toast-bottom-right',
      timeOut: 6000
    });
  }
}else{
    this.toastr.error("Please Selecct the Page Name", undefined, {
      positionClass: 'toast-bottom-right',
      timeOut: 6000
    });
  }
  }

  getimageuploadlist(){
     
  this.loginservice.getimageuploadlist().subscribe((res:any) => {
    if(res.responseBody != undefined){
      console.log("Image upload Listing :", res.responseBody.uploadlist);
      this.imguploadList = res.responseBody.uploadlist;
      console.log("Listing:", this.imguploadList)
      this.dataSource = new MatTableDataSource(this.imguploadList);
      this.dataSource.paginator = this.paginator;
    }
    
  })
  }

viewImg(element){
   
  var id =element.no;
  const url = this.global.Baseurl+this.global.viewImg+"/"+id;
  console.log(url)
  window.open(url);
}

}
